import GuideManager from './GuideManager';

export {};
declare global {
  interface Window {
    Getdemo: any;
  }
}

GuideManager.getInstance().start();
